import { useRef } from 'react';
import { NotificationProvider } from '@components';
import { Dashboard } from '@app/pages';
import { useAppCookies } from '@app/providers/AppCookieProvider';

// Broke out this component so I can use cookies.
// this also allows me to pull the router up to main.tsx
// and then use useNavigate for the main menu instead
// of window.location.href
export const DashboardWithCookies = () => {
  const cookies = useAppCookies();

  // Latch availability: the profile cookie can momentarily read unavailable while
  // react-cookie re-emits during a session/token refresh. Gating <Dashboard/> directly on
  // `cookies.profile.available` would unmount and remount it on every such blip, and each
  // remount resets the dashboard's internal loading state — that's the "loading -> content
  // -> loading -> content" flicker. Once the profile has been available we keep the
  // dashboard mounted so those transient dips don't tear it down.
  const hasBeenAvailable = useRef(false);
  if (cookies.profile.available) {
    hasBeenAvailable.current = true;
  }

  return <NotificationProvider>{hasBeenAvailable.current ? <Dashboard /> : null}</NotificationProvider>;
};
